/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "grUiutptgdY",
    thumbnail: "https://i.ytimg.com/vi/grUiutptgdY/mqdefault.jpg",
    // thumbnail: "https://i.ytimg.com/vi/d32De5pXTvo/0.jpg",
    // thumbnail: "https://i.ytimg.com/vi/d32De5pXTvo/maxresdefault.jpg",
    title: "Chip Malfunctioning? | GTA 5 VLT RP",
    creatorAvatar:
      "https://yt3.ggpht.com/bFcWV9lknV_caP05PC4fWXf7mF9eiTTVvZ0cMbJ5vzNGry6KdZdtDJ1NdG3L3O0hObPK2fQH1Q=s48-c-k-c0x00ffffff-no-rj",
    creator: "Exion",
    // duration: "44:20",
    views: "10K",
    category: "Roleplay",
    description: `💲 Become A Member • https://bit.ly/3aTNOKm
💲 Donation Via UPI • eexsion@okhdfcbank
💲 Donation Via PayPal • https://bit.ly/2VhqxvA
 
All tips are appreciated but unnecessary 😄

📷 Instagram • https://www.instagram.com/theexionhd
🕊️ Twitter • https://twitter.com/exionhd
😃 Discord • https://discord.gg/QdQqtGK
🕹️ Twitch • http://twitch.tv/exionhd
🌐 Website • https://exion.live

#vlt #gtarp`,
  },

  {
    _id: "bJip27JLNps",
    thumbnail: "https://i.ytimg.com/vi/bJip27JLNps/mqdefault.jpg",
    title:
      "Successful Code Red ✔️ Criminals NHK ✔️ | GTA 5 RP Live Stream India",
    creatorAvatar:
      "https://yt3.ggpht.com/ytc/AKedOLTPYzMbMQSkvxTeWbcNj1JPVpQM97sSdVj6a3pLbA=s48-c-k-c0x00ffffff-no-rj",
    creator: "RakaZone Gaming",
    views: "133K",
    category: "Roleplay",
    description: `💲 UPI • rakazonegaming@oksbi
💲 Sponsor • https://goo.gl/zMrr3K 
💲 Donation Via PayPal • https://goo.gl/1isdQj 
 Every Tip Is Appreciated 🙏

Sponsors:
boAt brings the best of gaming & music experience together! Go Immortal with boAt Immortal IM1300 Bluetooth Gaming Headset: https://www.amazon.in/shop/rakazonega...

Play like the pro's with gaming monitors from LG Ultra Gear - https://amzn.to/3ll6yVj 

Affiliate • https://www.amazon.in/shop/rakazonega...
📷 Instagram • https://www.instagram.com/rakazonegam...
🕊️ Twitter • https://twitter.com/rakazonegaming
👍  FB Page • https://www.facebook.com/RakaZoneGaming
😃 Discord • https://discord.gg/z7uj5kF
👪 Steam Group • http://steamcommunity.com/groups/Raka...
🕹️ Twitch • http://twitch.tv/rakazone


🖥️ PC Specs
• i9 9900K , 32 GB DDR4 RAM , ASUS ROG Strix  Z390-F, GPU RTX 3080 
• Camera - Logitech C-922 
• Mic- Samson c03u
• Headset - boAt Immortal IM1300 Gaming
• Keyboard - Logitech G613 Wireless Mechanical Keyboard
• Mouse -  Logitech G304 Wireless Gaming Mouse
• Monitor - LG Ultragear 27Inch

💰 Benefits Of Being A Sponsor 💰

• Get's a custom badge & Emoji's 
• Can play with me on non-sub games
• Can join discord voice channel on non-sub games
• Participate in Sponsor's only Giveaway's.

About RakaZone Gaming 👦🏻

• Rishab Karanwal
• 29
• New Delhi, India

#VLTRP #GTA5 #GTARP`,
  },
  {
    _id: "BVvm1qrDbEc",
    thumbnail: "https://i.ytimg.com/vi/BVvm1qrDbEc/mqdefault.jpg",
    title: "Hela the Explorer | UwU | VLTRP | HelaAisha",
    creatorAvatar:
      "https://yt3.ggpht.com/yGhM8BeOgk_CxcMhYUir57etTi87T4iepSObQG5uTiDBAA6iFT8RLrfZ1UugSiHgTMKQzrHHBuw=s48-c-k-c0x00ffffff-no-rj",
    creator: "HelaAisha",
    views: "6.2K",
    category: "Roleplay",
    description: `🌺🌺🌺   SUPPORT THE STREAM   🌺🌺🌺

✨ Become a Member -  https://www.youtube.com/channel/UCNth...
✨ BOOYAH! - https://booyah.live/helaaisha

────────────────────────────────────────────────────────

💖💖💖   Social and Gaming Handles   💖💖💖 
 
🎆Discord - https://discord.gg/3JcYCsh5VF 
 
🎇Instagram - helaaisha - https://instagram.com/helaaisha 
 
🎆Twitch - https://www.twitch.tv/helaaisha

 
────────────────────────────────────────────────────────

⚜️⚜️⚜️   Games I play   ⚜️⚜️⚜️

💠 GTA RolePlay 💠 Valorant 💠 Genshin Impact 💠 Minecraft 💠 PUBG 💠 BGMI 💠 Scavengers 💠 EFT 💠 Human Fall Flat 💠 Among Us 💠 Red Dead Online 💠 It Takes Two 💠 Life Is Strange 💠 Deceit 💠 CSGO 💠 Pummel Party 💠 Fall Guys 💠 Stumble Guys 💠  Rainbow Six Siege 

────────────────────────────────────────────────────────

✨✨✨   PC SPECS   ✨✨✨

🎊 CPU - 9th Gen Intel® Core™ i9-9900K 
🎉 Motherboard - Asus ROG Strix Z390-E 
🎊 GPU - Nvidia GeForce RTX 2080 Super 
🎉 RAM - G.Skill Trident Z RGB Series DDR4  
🎊 Liquid Cooler - Deepcool GamerStorm Castle 360EX 
🎉 Monitor 1 - BenQ Zowie XL2720 27 Inch
🎊 Monitor 2 - Samsung LED Backlit Monitor 
🎉 Keyboard 1  -  Razer BlackWidow Elite 
🎊 Keyboard 2  -  Ducky One 2 SF
🎉 Mouse  -  Razer Viper Ultimate 
🎊 Mousepad  -  AmazonBasics (Extended) 
🎉 Headset  - Razer Kraken Kitty RGB USB Gaming Headset
🎊 Mic  - Razer Seiren Emote 
🎉 Cabinet - Lian Li PC-O11 Dynamic Razer Edition

────────────────────────────────────────────────────────

🌈 Thumbnail Credit - By some lovely peeps from my DC server 🥰

────────────────────────────────────────────────────────

🌸🌸🌸  ABOUT ME  🌸🌸🌸

❄️ Aisha Ray
🧸 Age - dil se sweet 16 😜
🌈 Bhubaneswar, Odisha


🎉 xoxo 🎊`,
  },

  {
    _id: "ojaNRy-vgu4",
    thumbnail: "https://i.ytimg.com/vi/ojaNRy-vgu4/mqdefault.jpg",
    title: "HYDRA PUBG - 22 KILL SOLO RECORD ",
    creatorAvatar:
      "https://yt3.ggpht.com/2hJEOigX17s53Ta8STiV3kC7EtrrXjz1spwwx61REt74I1jQVd-OKHG-FFDSdbOYn0Xqqtcb=s48-c-k-c0x00ffffff-no-rj",
    creator: "HydraFlick",
    views: "169K",
    category: "Battle Royale",
    description: ` MERCH : http://hydraflick.com

Uploading some of my best plays in PUBG, hit like if you enjoyed my video :-] 

Don't forget to watch till the end.  Highlights are from my daily stream! : ) Like, Subscribe and share!
------------------------------------------------------------------ 
► Follow me on Instagram for updates : https://www.instagram.com/rohan_ledwani/
------------------------------------------------------------------

Thanks for watching. pce! #pubgpc #gamer #trending #pcgamer`,
  },

  {
    _id: "SNezqplrhtw",
    thumbnail: "https://i.ytimg.com/vi/SNezqplrhtw/mqdefault.jpg",
    title: "🔴 PUBG PC with RakaZone Gaming ( 2 wins ) | Live Stream ",
    creatorAvatar:
      "https://yt3.ggpht.com/ytc/AKedOLTPYzMbMQSkvxTeWbcNj1JPVpQM97sSdVj6a3pLbA=s48-c-k-c0x00ffffff-no-rj",
    creator: "RakaZone Gaming",
    views: "1.3K",
    category: "Battle Royale",
    description: `Support the stream ►: https://streamlabs.com/dannysgaming 
If you like the stream make sure you hit that like button in the face..
and tap that subscribe button....

Top Donator :- 
Pranav G - Rs 3000
Auro Jena - Rs 1000
Commands ►:- !discord , !paytm , !twitch , !steamid , !giveaway , !steamgroup , !pcspecs , !smurfid , !rank , !soundcloud , !Coins 
Best way to experience stream ►:-https://gaming.youtube.com/channel/UC...
Follow me On ►:-
DannySGaming ►:- https://www.youtube.com/channel/UCNPo...
Instagram► : dhanursharma13
SnapChat ►: dhanursharma 
Soundcloud► : officialdhanur
Join My Discord►:-  https://discord.gg/SVGQV56
SteamID :- http://steamcommunity.com/id/Official...
Steam Group ►: http://steamcommunity.com/groups/Dann...
Uplay :- DannnyyS
Music provided by NoCopyrightSounds 

PC Specifications :-
Cabinet :- AORUS AC300W (rev. 1.0) RGB 
Motherboard :- AORUS GA-AX370-Gaming K5 RGB 
Graphic Card :- AORUS-6GD AORUS GeForce GTX 1060 6GB RGB
Ram :- Corsair Vengeance LPX 8GB 1x8GB DDR4 DRAM 3000MHz
Processor :- AMD Ryzen 5 2600
SSD:- WD 120 GB Solid State Drive 
Power Supply :- Corsair VS550 550-Watt Power Supply
                                
Gaming Gear :-
Headset - Razer Kraken Pro V2
Keyboard - HyperX Alloy Elite Mechanical Gaming Keyboard (Cherry MX Red) 
Mouse - Corsair Harpoon RGB 6000 DPI Optical Sensor
Mousepad - Razer Firefly Mousepad
Mic - Generic Professional Condenser Microphone Mic Sound Studio Recording 
Controller - Logitech Wireless Gamepad F710
Monitor - AOC 21 Inch Led Gaming Screen`,
  },

  {
    _id: "NBZ5Q0cjLz4",
    thumbnail: "https://i.ytimg.com/vi/NBZ5Q0cjLz4/mqdefault.jpg",
    title: "RAFT Gameplay | Playing with friends | Chill night stream",
    creatorAvatar:
      "https://yt3.ggpht.com/Vpt17etCCsPm5oVRklTBX5kWZb3ief6vUe99CeP9rGUSP0Ea0tlwGakTSm8nHRiEWhjW5SR7=s48-c-k-c0x00ffffff-no-rj",
    creator: "8bit Binks69",
    views: "72K",
    category: "Adventure",
    description: ` Support the stream: https://streamlabs.com/binks69 #Live #Binks #Valorant #s8ul 

🔶🔸🔶🔸   Membership  🔸🔶🔸🔶

Become A Member :- 
https://www.youtube.com/channel/UCSQ7...
Donate GPAY/PAYTM : 9137636368

🔶🔸🔶🔸   Social  🔸🔶🔸🔶

•Discord - https://discord.gg/TJMCqVP
•Instagram :- https://www.instagram.com/8bit_binks/
•Facebook :- https://m.facebook.com/Binks69-102938...
•Email :-  binks69@8bitcreatives.in

🔶🔸🔶🔸   About  🔸🔶🔸🔶

• Mithul Nayak
•Studied: B.com
•Age: 29
•Location: Mumbai, India. 

🔶🔸🔶🔸   P.C. Specs  🔸🔶🔸🔶

•Processor - AMD Ryzen 9 5900X
•RAM - 32 GB Corsair RGB 
•Storage - AORUS Gen4 SSD
•Headphone - SteelSeries Arctis 7S
•Keyboard - Steel Series Apex 64145 
•Mouse - Logitech Gpro
•Cpu Cooler - CORSAIR H150 RGB 360MM LIQUID CPU COOLER
•Case - Corsair 4000D Airflow Tempered Glass Mid-Tower ATX
•Power supply - Antec HCG x 1000 PSU


Managed by 8Bit Thug ❤️ 
Managed by  8bit Creatives - https://www.instagram.com/8bit_creati...
Business mail - binks69@8bitcreatives.in

Do Like Share & Subscribe :)
GEELI CHUMMI TO ALL :*`,
  },
  {
    _id: "azXLPtMVmx0",
    thumbnail: "https://i.ytimg.com/vi/azXLPtMVmx0/mqdefault.jpg",
    title: "Using Fortune III on Diamonds in Minecraft *EPIC* - Part 17",
    creatorAvatar:
      "https://yt3.ggpht.com/g14fYY-BB0G1EJyiZp0tmLH_eMM1XTG0Na-wU8E_F4JxjF4QQl6aQNyZEvFSoPo_8qfOfLI6wKk=s48-c-k-c0x00ffffff-no-rj",
    creator: "BeastBoyShub",
    views: "12M",
    category: "Adventure",
    description: `Gawd Damn, This fortune 3 Enchantment is the best of em' all. I'll be rich in no time with this..... So many diamonds from a single spot lol

Minecraft is so much more fun now hahahahaha

#Minecraft #Diamonds #Beastboyshub #Youtubegaming #Minecraftfortune3 #Enchantments`,
  },
  {
    _id: "uhcPWulNq-A",
    thumbnail: "https://i.ytimg.com/vi/uhcPWulNq-A/mqdefault.jpg",
    title: "VALORANT LIVE STREAM INDIA WITH VLT TBONE",
    creatorAvatar:
      "https://yt3.ggpht.com/M2dCsLTBPiSwoDUGR1UV9xigwZJyki5IevleZv2QcQnI417ERnnSZ5BOWCo2drwM6yiWizkJ=s48-c-k-c0x00ffffff-no-rj",
    creator: "TbOne",
    views: "62K",
    category: "FPS",
    description: `#TBONE #VLT #VALORANTLIVE
💲 Sponsor • https://www.youtube.com/TbOneTV Click on Join
💲 Donation Via PayPal • https://streamlabs.com/tbonegaming
• Check out the latest line-up of RedGear peripherals: https://www.amazon.in/shop/tbone
• ROG is World's premier Gaming Laptop Brand, Know more: https://rog.asus.com/in/laptops-group
🕹️ Loco • https://loco.onelink.me/65Kg/TbOneTV
📷 Instagram • https://www.instagram.com/tbonegaming
🕊️ Twitter • https://twitter.com/tbonegamng
👍  FB Page • https://www.facebook.com/TbOneGaming

🖥️ PC Specs
• Intel® Core™ i7-8700K Processor
• ASRock Z370 Taichi
• Cooler Master V1000 Fully Modular 80 PLUS Gold
• ADATA XPG D40 DDR4 RGB 3200MHz (8*4) 
• Phanteks Enthoo Evolv ATX - Silver
• Samsung 970 Evo Series 250GB PCIE NVME - M.2
• Seagate 2TB Firecuda 
• Cooler Master MasterLiquid ML240R All-in-one
• ZOTAC GAMING GeForce RTX 3080 Ti AMP Extreme Holo RESIDENT EVIL`,
  },
  {
    _id: "PfIa8SAM6iQ",
    thumbnail: "https://i.ytimg.com/vi/PfIa8SAM6iQ/mqdefault.jpg",
    title: "Escape From Tarkov Funny Moments 🤣😂",
    creatorAvatar:
      "https://yt3.ggpht.com/ytc/AKedOLTPYzMbMQSkvxTeWbcNj1JPVpQM97sSdVj6a3pLbA=s48-c-k-c0x00ffffff-no-rj",
    creator: "RakaZone Gaming",
    views: "70K",
    category: "FPS",
    description: `As you guys asked for .exe video here it is some of the funny & amazing moments from Escape From Tarkov Live Stream

Video By:- Ritz is live

RakaZone Gaming Socials •
📷 Instagram • https://www.instagram.com/rakazonegaming
🕊️ Twitter • https://twitter.com/rakazonegaming
👍  FB Page • https://www.facebook.com/RakaZoneGaming
🕹️ Twitch • http://twitch.tv/rakazone

#RakaZoneGaming #EFT #EscapeFromTarkov`,
  },
  {
    _id: "N5cuZsba_g0",
    thumbnail: "https://i.ytimg.com/vi/N5cuZsba_g0/mqdefault.jpg",
    title: "The OG CSGO King TBONE",
    creatorAvatar:
      "https://yt3.ggpht.com/M2dCsLTBPiSwoDUGR1UV9xigwZJyki5IevleZv2QcQnI417ERnnSZ5BOWCo2drwM6yiWizkJ=s48-c-k-c0x00ffffff-no-rj",
    creator: "TbOne",
    views: "138K",
    category: "FPS",
    description: `#csgo #csgofunny #tbonecsgo
► SUBSCRIBE AND FOLLOW!
Instagram: https://www.instagram.com/tbonegaming`,
  },
  {
    _id: "VRmNlL84ceA",
    thumbnail: "https://i.ytimg.com/vi/VRmNlL84ceA/mqdefault.jpg",
    title: "GTA 5 ROLE PLAY LIVESTREAM VLTRP JOSEPH CHACHA",
    creatorAvatar:
      "https://yt3.ggpht.com/M2dCsLTBPiSwoDUGR1UV9xigwZJyki5IevleZv2QcQnI417ERnnSZ5BOWCo2drwM6yiWizkJ=s48-c-k-c0x00ffffff-no-rj",
    creator: "TbOne",
    views: "122K",
    category: "Roleplay",
    description: ` #GTA5 #GTA5RP #VLTRP
💲 Sponsor • https://www.youtube.com/TbOneTV Click on Join
💲 Donation Via PayPal • https://streamlabs.com/tbonegaming
• Check out the latest line-up of RedGear peripherals: https://www.amazon.in/shop/tbone
• ROG is World's premier Gaming Laptop Brand, Know more: https://rog.asus.com/in/laptops-group
🕹️ Loco • https://loco.onelink.me/65Kg/TbOneTV
📷 Instagram • https://www.instagram.com/tbonegaming
🕊️ Twitter • https://twitter.com/tbonegamng
👍  FB Page • https://www.facebook.com/TbOneGaming

🖥️ PC Specs
• Intel® Core™ i7-8700K Processor
• ASRock Z370 Taichi
• Cooler Master V1000 Fully Modular 80 PLUS Gold
• ADATA XPG D40 DDR4 RGB 3200MHz (8*4) 
• Phanteks Enthoo Evolv ATX - Silver
• Samsung 970 Evo Series 250GB PCIE NVME - M.2
• Seagate 2TB Firecuda 
• Cooler Master MasterLiquid ML240R All-in-one
• ZOTAC GAMING GeForce RTX 3080 Ti AMP Extreme Holo RESIDENT EVIL

🖥️ Streaming PC specs
• CPU: i5 6600K 3.3GHZ 
• M/B: GIGABYTE H110
• GPU: GIGABYTE G1 GAMING 1060 6GB
• RAM: 16GB DDR4 Corsair Vengeance
• STORAGE: WD 1 TB Blue & WD 120GB SSD
• ELGATO HD60 Capture card.

💰 Benefits Of Being A Sponsor 💰

• Get's a custom badge & Emoji's 
• Access to member only streams. 
• Participate in Sponsor's only Giveaway's.
• The OnlyFrands Sponsor will have access to exclusive whats app group

About TbOne 👦🏻

• Shobith Rai
• 30
• Bangalore, India`,
  },
  {
    _id: "6I1z7Ixq1Jo",
    thumbnail: "https://i.ytimg.com/vi/6I1z7Ixq1Jo/mqdefault.jpg",
    title: "Only wins today I Valorant live stream w OG CaspeR ",
    creatorAvatar:
      "https://yt3.ggpht.com/wZvcqr36Il2tIIRAWNix1VzfQiRM3U6uK9np4H-OIv-8605IwqIWKPkSIVHX8_f5WovJXsOkpQ=s48-c-k-c0x00ffffff-no-rj",
    creator: "CaspeR",
    views: "10K",
    category: "FPS",
    description: `★https://linktr.ee/AMDgaminguniverse
★MD Computers: https://mdcomputers.in/aorus-premier-...
Support the stream: https://streamlabs.com/casper68 Neha ( Casper )  Sottany
Professional Esports Athlete / Orangutan.gg
:━━━━━━━━━━━━━━━━━━━━:
★My Achievements-
★ Runners Up Legion of Valkyrie 2019 ( Thailand )
★Runners Up of Legion of Valkyrie 2021  ( India )
★Runners Up of Aorus Showstopper Series Valorant (Team 4)
★ Champions of AMD presents Streamer Quest ( Team Charlie )
★Champions of Aorus Premier League ( MD Computers )
:━━━━━━━━━━━━━━━━━━━━:
★TWITTER - https://twitter.com/CaspeRMineK
★INSTAGRAM -​https://www.instagram.com/casperminek/
★Discord - https://discord.gg/tpWUxvgaMG
★Donate through upi - sottanyneha@okhdfcbank
★STEAM LINK - https://steamcommunity.com/profiles/7...
★FACEBOOK - https://www.facebook.com/neha.sottany
★BUSINESS MAIL- sottanyneha@gmail.com
:━━━━━━━━━━━━━━━━━━━━:`,
  },
  {
    _id: "JqJfNTO4dkI",
    thumbnail: "https://i.ytimg.com/vi/JqJfNTO4dkI/mqdefault.jpg",
    title: "Viper Smoke Demon 😈 | Best Viper Outplays India",
    creatorAvatar:
      "https://yt3.ggpht.com/ytc/AKedOLRwXwUhslr89z7MMMHw19ARf2kHTFSMn8mS8DcrOg=s48-c-k-c0x00ffffff-no-rj",
    creator: "Harsh Khelraay",
    views: "19K",
    category: "FPS",
    description: `Edited By : https://www.instagram.com/4man_vfx/
                   https://twitter.com/4man_vfx
Discord : https://discord.gg/sbvq5GU5YX
My Instagram : https://www.instagram.com/iam_harsh__/
Social Media Handles : ( Link tree )  https://linktr.ee/iam_harsh__

Donation Via UPI : harshsalunkheh@oksbi

Check out the best of RedGear gaming peripherals here: www.amazon.in/redgear

Choosing the right GPU and getting it at the right price can get really tricky. Thanks to Colorful’s wide range of GPUs and their remarkable customer service, there’s one thing you can tick off your checklist easily. Go check them out: https://en.colorful.cn/product.aspx?m...

Exit Lag : Fix your high ping and lag ! Get exitlag Free for 3 days ! http://exitl.ag/harsh​​​​ 
Use code " harsh " to get 20 % OFF !


Check out my rig ! 
CPU - https://www.amazon.in/dp/B07SXMZLPK?t...
GPU - Colorful RTX 3070
RAM - 24 GB Corsair 3000 MHZ : https://www.amazon.in/dp/B07W8ZDDKT?t...
Monitor - Acer kg241q 144 Hz
Handcam - https://www.amazon.in/dp/B08DCGTS91?t...
Earphones - https://www.amazon.in/Redgear-CEB-150...
Keyboard - https://www.amazon.in/dp/B08T28HSDN?t...
Mouse ( Redgear ) - https://www.amazon.in/dp/B09FLD6BJN?t...
Mouse - https://www.amazon.in/dp/B084W6W9WB?t...
Phone - https://www.amazon.in/dp/B07PKTGR91?t...
Cabinet - https://www.amazon.in/dp/B07VCK2M9T?t...
Mousepad - https://www.amazon.in/dp/B07J68QGR6?t...
Hand sleeves : https://www.amazon.in/dp/B07D5DKZDY?t...
Mic : https://www.amazon.in/dp/B09374KTPK?t...
Monitor Arm : https://www.amazon.in/dp/B076B3Q8JR?t...
Graphics Tablet : https://www.amazon.in/dp/B017ATNRTY?t...
Water Bottle : https://www.amazon.in/dp/B07TVD8183?t...
_
#valorant #vipervalorant`,
  },
];
